const linksEn = [
	{
		path: '/en/degree/',
		home: true,
	},
	{
		path: '/en/programmes/skolkovo-mba/',
		name: 'SKOLKOVO MBA',
		active: true,
	},
	{
		path: '/en/programmes/skolkovo-executive-mba/',
		name: 'SKOLKOVO Executive MBA',
		active: true,
	},
	{
		path: '/en/programmes/master-in-management-analytics/',
		name: 'SKOLKOVO MMA',
		active: false,
	},
];

export default linksEn;
